import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Weight extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): Weight {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new Weight(value);
  }

  /** ラベル */
  static get label(): string {
    return '体重(kg)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '20';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {};
  }

  /** キー */
  static get key() {
    return 'weight';
  }

  /** タイプ */
  static get type() {
    return 'number';
  }
}
